/**
 * Team type enum. Each value maps to one color and one icon (icon-team-type-N.png).
 * Used for styling and default subtitles; per-team-member subtitle overrides are optional.
 */
export enum TeamType {
  Administration = 1,
  Frontend = 2,
  Backend = 3,
  Marketing = 4,
  Sales = 5,
}

export default TeamType;
